import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import Logo, { TocoaScript } from '../components/Logo';
import { useApp } from '../context/AppContext';
import { IMAGES } from '../lib/constants';

const AdminLogin = () => {
  const { signIn } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error('Ingresa tus credenciales');
    setBusy(true);
    try {
      await signIn('admin', email, password);
      toast.success('Bienvenido al panel de Delibery 7');
      navigate('/admin');
    } catch { /* toast shown by context */ } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="relative hidden lg:block bg-[#1E2130]">
        <img src={IMAGES.rider} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1E2130] via-[#1E2130]/60 to-transparent" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <Logo size="md" dark />
          <div>
            <TocoaScript light className="text-6xl" />
            <p className="text-3xl font-extrabold mt-2">Tu ciudad, en tus manos</p>
            <p className="text-white/70 mt-3 max-w-md">Panel central de administración: pedidos, restaurantes, conductores, comprobantes y métricas en un solo lugar.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-md fade-up">
          <button type="button" onClick={() => navigate('/')} className="text-sm text-gray-500 flex items-center gap-1 mb-8 hover:text-[#1E2130]"><ArrowLeft size={16} /> Volver</button>
          <div className="lg:hidden mb-8"><Logo size="md" /></div>
          <h1 className="text-3xl font-extrabold text-[#1E2130]">Panel de Administrador</h1>
          <p className="text-gray-500 mt-1">Inicia sesión para continuar</p>

          <label className="block mt-8">
            <span className="text-xs font-semibold text-gray-500">Correo electrónico</span>
            <div className="mt-1.5 flex items-center gap-3 h-12 px-4 rounded-xl border border-gray-200 bg-[#F7F8FA] focus-within:border-[#EE3B36] focus-within:ring-2 focus-within:ring-[#EE3B36]/20">
              <Mail size={18} className="text-gray-400" />
              <input data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="flex-1 bg-transparent outline-none text-sm" placeholder="admin@delivery7tocoa.com" />
            </div>
          </label>
          <label className="block mt-4">
            <span className="text-xs font-semibold text-gray-500">Contraseña</span>
            <div className="mt-1.5 flex items-center gap-3 h-12 px-4 rounded-xl border border-gray-200 bg-[#F7F8FA] focus-within:border-[#EE3B36] focus-within:ring-2 focus-within:ring-[#EE3B36]/20">
              <Lock size={18} className="text-gray-400" />
              <input data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} type={show ? 'text' : 'password'} className="flex-1 bg-transparent outline-none text-sm" placeholder="Contraseña" />
              <button type="button" onClick={() => setShow((s) => !s)} className="text-gray-400">{show ? <EyeOff size={18} /> : <Eye size={18} />}</button>
            </div>
          </label>
          <button type="submit" data-testid="admin-login-btn" disabled={busy} className="mt-6 w-full h-12 rounded-xl bg-[#EE3B36] text-white font-semibold hover:bg-[#D93129] active:scale-[0.99] transition-colors shadow-lg shadow-red-500/25 disabled:opacity-60">{busy ? 'Ingresando...' : 'Iniciar sesión'}</button>
          <p className="text-center text-xs text-gray-400 mt-4">Acceso exclusivo del propietario. Cambia tu contraseña en Accesos y contraseñas.</p>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
